import { render, staticRenderFns } from "./trainingStatistics.vue?vue&type=template&id=6d9d3f38&scoped=true"
import script from "./trainingStatistics.vue?vue&type=script&lang=js"
export * from "./trainingStatistics.vue?vue&type=script&lang=js"
import style0 from "./trainingStatistics.vue?vue&type=style&index=0&id=6d9d3f38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9d3f38",
  null
  
)

export default component.exports